// Initialises all modal instances on the page
function Modal() {
  const modals = document.querySelectorAll("[data-modal-root]");

  if (!modals.length) return;

  modals.forEach((modal) => {
    setupModal(modal);
  });

  setupGlobalTriggers();
}

// Sets up behaviour for a single modal instance
function setupModal(modal) {
  const closeBtn = modal.querySelector(".c-modal__close");

  if (!closeBtn) return;

  let lastFocused = null;

  const focusableSelectors =
    'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';

  // Gets all focusable elements inside the modal
  function getFocusable() {
    return modal.querySelectorAll(focusableSelectors);
  }

  // Keeps keyboard focus trapped inside the modal
  function trapFocus(e) {
    if (e.key !== "Tab") return;

    const focusable = getFocusable();
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  // Opens the modal
  function openModal() {
    lastFocused = document.activeElement;

    modal.hidden = false;

    requestAnimationFrame(() => {
      modal.classList.add("is-open");
    });

    document.documentElement.style.overflow = "hidden";

    const focusable = getFocusable();
    (focusable[0] || closeBtn).focus();

    modal.addEventListener("keydown", trapFocus);

    modal.dataset.state = "open";
  }

  // Closes the modal and restores focus
  function closeModal() {
    modal.classList.remove("is-open");
    document.documentElement.style.overflow = "";

    modal.removeEventListener("keydown", trapFocus);

    modal.addEventListener(
      "transitionend",
      () => {
        modal.hidden = true;
        lastFocused?.focus();
      },
      { once: true },
    );

    modal.dataset.state = "closed";
  }

  // Close modal when close button is clicked
  closeBtn.addEventListener("click", closeModal);

  // Close modal when clicking outside the dialog
  modal.addEventListener("click", (e) => {
    if (e.target === modal) closeModal();
  });

  // Close modal when pressing Escape
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && modal.classList.contains("is-open")) {
      closeModal();
    }
  });

  // Expose open/close methods for global triggers
  modal.__open = openModal;
  modal.__close = closeModal;
}

// Sets up global click triggers for all modals
function setupGlobalTriggers() {
  document.addEventListener("click", (e) => {
    const trigger = e.target.closest("[data-modal-open]");
    if (!trigger) return;

    const id = trigger.getAttribute("data-modal-open");
    if (!id) return;

    const modal = document.querySelector(`[data-modal-root="${id}"]`);
    if (!modal || !modal.__open) return;

    e.preventDefault();

    modal.__open();
  });
}

export default Modal;
